import React from 'react';

const Events = () => {
    return (
        <div className="events-content">
            <h3>Event Details</h3>
            <p><strong>Race Location:</strong> Boracay Island, Philippines 🇵🇭 </p>
            <p><strong>Race Date:</strong> May 15-17, 2026</p>
            <p><strong>Race Fees $USD:</strong> $150 (Flat Entry Fee)</p>
            <a href="/RC_boracay_rules.pdf" download className="download-link">
                Download Official Rules (PDF)
            </a>
            
            <div style={{ marginTop: '25px', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}>
                <iframe
                    title="Boracay Island Race Location Map"
                    width="100%"
                    height="350"
                    style={{ border: 0, display: 'block' }}
                    src="https://maps.google.com/maps?q=Boracay+Island,+Philippines&t=&z=13&ie=UTF8&iwloc=&output=embed"
                    allowFullScreen
                    loading="lazy"
                ></iframe>
            </div>
        </div>
    )
}

export default Events;
